import type { ContentState } from './types.ts';

export const isDuplicate = (color: string, name: string, array: (ContentState | null)[]) => {
	// toLowerCase the color since BE stores colors with lowercase letters
	const lowerCaseColor = color.toLowerCase();
	const duplicate = array.filter(
		(status: { color: string | null; name: string | null } | null) =>
			status?.color === lowerCaseColor && status?.name === name,
	);

	return duplicate.length === 1;
};
